export default request => new Promise((resolve) => {
  new window.google.maps.Geocoder().geocode(request, (results, status) => {
    if (status !== 'OK' || !results[0]) {
      throw new Error(`Invalid response from Google Search API. Status: ${status}. Empty? ${!results[0]}`);
    }
    resolve(results);
  });
});
